import { render, staticRenderFns } from "./AnalyticsManufacturer.vue?vue&type=template&id=0564f476&"
import script from "./AnalyticsManufacturer.vue?vue&type=script&lang=js&"
export * from "./AnalyticsManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports